<button mat-button class="close-button" mat-dialog-close>
  <span class="material-symbols-outlined close-icon">
    close
  </span>
</button>
<div class="carousel-container" *ngIf="slides.length > 0">
  <c-carousel [touch]="true" [interval]="0">
    <c-carousel-indicators *ngIf="slides.length > 1"></c-carousel-indicators>
    <c-carousel-inner>
      <c-carousel-item *ngFor="let slide of slides">
        <img [src]="slide.src" [alt]="slide.title" class="responsive-image" fetchpriority="high" />
      </c-carousel-item>
    </c-carousel-inner>
    <c-carousel-control *ngIf="slides.length > 1" class="carousel-control" caption="Previous" direction="prev"></c-carousel-control>
    <c-carousel-control *ngIf="slides.length > 1" class="carousel-control" caption="Next" direction="next"></c-carousel-control>
  </c-carousel>
</div>
